import { render, staticRenderFns } from "./account_supdeduct_list.vue?vue&type=template&id=5b8f5290"
import script from "./account_supdeduct_list.vue?vue&type=script&lang=js"
export * from "./account_supdeduct_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports